import React, { useState } from 'react';

const MultiButtonPage = ({ 
  mainHeading = "Which best describes your Health Insurance Coverage?",
  description = "Click to be connected with a licensed sales agent to check your eligibility to enroll and to review your Medicare Advantage plan options.",
  continueButtons = [
    "Continue 1",
    "Continue 2", 
    "Continue 3",
    "Continue 4",
    "Continue 5",
    "Continue 6",
    "Continue 7"
  ],
  noButton = "No Thanks",
  skipButton = "Learn More",
  disclaimerText,
  smid = "MULTI-PLAN_maia1002_2026_C"
}) => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    zipCode: '',
    email: '',
    phoneNumber: ''
  });
  const [errors, setErrors] = useState({});
  const [showThankYou, setShowThankYou] = useState(false);
  const [showDenied, setShowDenied] = useState(false);
  const [showAgentWaiting, setShowAgentWaiting] = useState(false);
  const [showNoResponse, setShowNoResponse] = useState(false);
  const [generalError, setGeneralError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
    // Clear general error when user starts typing
    if (generalError) {
      setGeneralError('');
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required.';
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last name is required.';
    }

    const zipCodeRegex = /^\d{5}(-\d{4})?$/;
    if (!zipCodeRegex.test(formData.zipCode)) {
      newErrors.zipCode = 'Please enter a valid ZIP code.';
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address.';
    }

    const phoneNumberRegex = /^\d{10}$/;
    if (!phoneNumberRegex.test(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Please enter a valid 10-digit phone number.';
    }

    setErrors(newErrors);
    
    // Set general error message if there are validation errors
    if (Object.keys(newErrors).length > 0) {
      setGeneralError('Please fill out all required fields before continuing.');
    } else {
      setGeneralError('');
    }
    
    return Object.keys(newErrors).length === 0;
  };

  const handleContinue = (buttonNumber, buttonText) => {
    // Define buttons that should lead to "No" response page
    const noResponseButtons = [
      'No Insurance',
      'Insurance Through Work', 
      'Private Insurance',
      'Only Medicaid'
    ];
    
    if (noResponseButtons.includes(buttonText)) {
      setShowNoResponse(true);
    } else if (validateForm()) {
      console.log(`Continue button ${buttonNumber} clicked`);
      setShowAgentWaiting(true);
    }
  };

  const handleNo = () => {
    setShowNoResponse(true);
  };

  const handleSkip = () => {
    setShowAgentWaiting(true);
  };

  const getCurrentDate = () => {
    const today = new Date();
    const month = (today.getMonth() + 1).toString().padStart(2, '0');
    const day = today.getDate().toString().padStart(2, '0');
    const year = today.getFullYear().toString().slice(-2);
    return `${month}/${day}/${year}`;
  };

  if (showNoResponse) {
    return (
      <div className="main-box" id="no-response">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 py-lg-5 py-4 px-lg-5 main-box__left" style={{ display: 'block', margin: '0 auto', textAlign: 'center', maxWidth: '900px' }}>
              <div className="no-response-container">
                <div className="no-response-icon">😔</div>
                <h2 className="no-response-title">Sorry, we won't be able to help you.</h2>
                <p className="no-response-description">
                  Thank you for your interest. Unfortunately, our services are not available for your current situation.
                </p>
                <div className="no-response-footer">
                  <p className="no-response-note">
                    If you have any questions, please contact Medicare directly at 1-800-MEDICARE.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showAgentWaiting) {
    return (
      <div className="main-box" id="agent-waiting">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 py-lg-5 py-4 px-lg-5 main-box__left" style={{ display: 'block', margin: '0 auto', textAlign: 'center', maxWidth: '900px' }}>
              <div className="agent-waiting-container">
                <div className="agent-waiting-icon">📞</div>
                <h2 className="agent-waiting-title">Skip the Line!</h2>
                <h3 className="agent-waiting-subtitle">An Agent is waiting for you now</h3>
                <p className="agent-waiting-description">
                  Get connected instantly with a licensed sales agent who can help you find the perfect Medicare plan.
                </p>
                <div className="call-button-container">
                  <a href="tel:+1-800-123-4567" className="call-now-button">
                    <span className="call-icon">📞</span>
                    <span className="call-text">Call Now</span>
                    <span className="call-number">1-800-123-4567</span>
                  </a>
                </div>
                <p className="agent-waiting-note">
                  Available 24/7 • No wait time • Licensed agents
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showThankYou) {
    return (
      <div className="main-box" id="clicktocall">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 py-lg-5 py-4 px-lg-5 main-box__left" style={{ display: 'block', margin: '0 auto', textAlign: 'center', maxWidth: '900px' }}>
              <div className="h2 fw-500 mb-4 text-center main-box__text-1">Thank You for your response!</div>
              <form className="baseform" id="survey-signup" data-prefix="su" style={{ margin: '0 auto', textAlign: 'left' }}>
                <div className="mb-4 text-center"></div>
                <p className="general-feedback general-feedback--fullform text-center" id="su-survey-signup-form-error"></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (showDenied) {
    return (
      <div className="main-box" id="clicktocalldenied">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 py-lg-5 py-4 px-lg-5 main-box__left" style={{ display: 'block', margin: '0 auto', textAlign: 'center', maxWidth: '900px' }}>
              <div className="h2 fw-500 mb-4 text-center main-box__text-1">Thank You for your response!</div>
              <form className="baseform" id="survey-signup" data-prefix="su" style={{ margin: '0 auto', textAlign: 'left' }}>
                <div className="mb-4 text-center"></div>
                <p className="general-feedback general-feedback--fullform text-center" id="su-survey-signup-form-error"></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="main-box" id="intro">
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12 py-lg-5 py-4 px-lg-5 main-box__left" style={{ display: 'block', margin: '0 auto', textAlign: 'center', maxWidth: '900px' }}>
            <div className="h2 fw-500 mb-4 text-center main-box__text-1">{mainHeading}</div>
            
            {/* Call-to-Action Section */}
            <div className="cta-section-condensed">
              <div className="cta-arrow">↓</div>
              <span className="cta-text-condensed">Please Enter Your Information Below</span>
            </div>
            
            <div className="form-container">
              <form className="baseform" id="survey-signup" data-prefix="su" style={{ margin: '0 auto', textAlign: 'left' }}>
                <p className="mb-4 text-center form-description">{description}</p>
                
                <div className="form-fields">
                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="su-first-name" className="form-label">First Name</label>
                      <input
                        type="text"
                        className={`form-control modern-input ${errors.firstName ? 'is-invalid' : ''}`}
                        id="su-first-name"
                        name="firstName"
                        placeholder="Enter your first name"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        autoFocus
                        autoComplete="on"
                      />
                      <p className="invalid-feedback">{errors.firstName}</p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="su-last-name" className="form-label">Last Name</label>
                      <input
                        type="text"
                        className={`form-control modern-input ${errors.lastName ? 'is-invalid' : ''}`}
                        id="su-last-name"
                        name="lastName"
                        placeholder="Enter your last name"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        autoComplete="on"
                      />
                      <p className="invalid-feedback">{errors.lastName}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="su-zip-code" className="form-label">ZIP Code</label>
                      <input
                        type="text"
                        className={`form-control modern-input ${errors.zipCode ? 'is-invalid' : ''}`}
                        id="su-zip-code"
                        name="zipCode"
                        placeholder="Enter your ZIP code"
                        value={formData.zipCode}
                        onChange={handleInputChange}
                      />
                      <p className="invalid-feedback">{errors.zipCode}</p>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label htmlFor="su-email" className="form-label">Email Address</label>
                      <input
                        type="email"
                        className={`form-control modern-input ${errors.email ? 'is-invalid' : ''}`}
                        id="su-email"
                        name="email"
                        placeholder="Enter your email address"
                        value={formData.email}
                        onChange={handleInputChange}
                        autoComplete="on"
                      />
                      <p className="invalid-feedback">{errors.email}</p>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6 mb-3">
                      <label htmlFor="su-phone-number" className="form-label">Phone Number</label>
                      <input
                        type="tel"
                        className={`form-control modern-input ${errors.phoneNumber ? 'is-invalid' : ''}`}
                        id="su-phone-number"
                        name="phoneNumber"
                        placeholder="Enter your phone number"
                        value={formData.phoneNumber}
                        onChange={handleInputChange}
                      />
                      <p className="invalid-feedback">{errors.phoneNumber}</p>
                    </div>
                    <div className="col-md-6 mb-3">
                      {/* Empty column for spacing */}
                    </div>
                  </div>
                </div>

              <div className="mb-2 position-relative">
                <input type="hidden" id="leadid_tcpa_disclosure" name="tcpa-disclosure" />
                <label className="disclaimer-text text-start text-gray-800" htmlFor="leadid_tcpa_disclosure">
                  <p className="text-break mb-0" dangerouslySetInnerHTML={{ __html: disclaimerText }}></p>
                </label>
              </div>

              {/* General Error Message */}
              {generalError && (
                <div className="mb-3 text-center">
                  <p className="text-danger fw-bold" style={{ fontSize: '16px' }}>
                    {generalError}
                  </p>
                </div>
              )}

                {/* Dynamic Continue Buttons */}
                <div className="mb-4 text-center button-container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px' }}>
                  {continueButtons.map((buttonText, index) => (
                    <div 
                      key={index}
                      className="btn-modern" 
                      onClick={() => handleContinue(index + 1, buttonText)} 
                      style={{ width: '250px' }}
                    >
                      {buttonText}
                    </div>
                  ))}
                
                  
                  {/* Skip Button */}
                  <div className="btn-modern" onClick={handleSkip} style={{ width: '250px' }}>
                    {skipButton}
                  </div>
                </div>

                <p className="general-feedback general-feedback--fullform text-center" id="su-survey-signup-form-error"></p>
                <p style={{ fontSize: '10px', textAlign: 'center' }}>
                  Participating sales agencies represent Medicare Advantage HMO, PPO and PFFS organizations and stand-alone PDP prescription drug plans that are contracted with Medicare. Enrollment depends on the plan's contract renewal. Enrollment in the described plan type may be limited to certain times of the year unless you qualify for a Special Enrollment Period or you are in your Medicare Initial Enrollment Period. <br />{smid}
                </p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MultiButtonPage;
